import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ValidationService } from 'src/app/services/validation.service';
import { LanguagesService } from 'src/app/services/language.service';
import { BaseService } from 'src/app/services/base.service';

  @Component({
    selector: 'head-family',
    templateUrl: './head-family.component.html'
  })
  export class HeadFamilyComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Output() onreset = new EventEmitter();
    @Output() activateMe = new EventEmitter();
    @Output() showTab = new EventEmitter<any>();
    @Output() nextTab = new EventEmitter<any>();
    isSubmited = false;
    isSocialID_Mandarory = true;

    constructor (public languagesService: LanguagesService,
        public baseService: BaseService) {
        
    }

    ngOnInit(): void {
      this.createFormControls();
      this.form.controls.state.disable();
    }

    createFormControls() {
        this.form.addControl('departure_date', new FormControl('', [ValidationService.DateRequired]));
        this.form.addControl('marital_status', new FormControl('', [Validators.required]));
        this.form.addControl('partner_returning', new FormControl(null, []));
        this.form.addControl('army_service', new FormControl('', [Validators.required]));
        this.form.addControl('content', new FormControl('', [ValidationService.specialCharactesValidator]));
        this.form.addControl('gov_check', new FormControl(null, [Validators.required]));
        this.form.addControl('children_up16_num', new FormControl('', []));
        this.form.addControl('children_up18_num', new FormControl('', []));
        this.form.addControl('returning_donation', new FormControl(null, [Validators.required]));
        this.form.addControl('moia_donation', new FormControl(null, [Validators.required]));
        this.form.addControl('scientist', new FormControl(null, [Validators.required]));

        
        this.form.addControl('residence_country', new FormControl('', [Validators.required]));
        this.form.addControl('city', new FormControl('', [Validators.required, ValidationService.textEnglishValidator]));
        this.form.addControl('phone_main',new FormControl('', [Validators.required, ValidationService.phoneValidator]));
        this.form.addControl('phone_adv', new FormControl('', [ValidationService.phoneValidator]));
        this.form.addControl('email', new FormControl('', [Validators.required, ValidationService.emailValidator]));
        this.form.addControl('state', new FormControl('', []));
        this.form.addControl('probable_city', new FormControl('', [Validators.required]));
    }

    public get f() {
        return this.form.controls;  
    }

    onReset() {
        const arr = <FormArray>this.form.controls.arr;
        while (arr.length !== 0) {
            arr.removeAt(0)
          }
        this.createFormControls();
        this.onreset.emit();
    }

    armyServiceChanged() {
        this.form.controls.content.setErrors(null);
        this.form.controls.content.setValidators(
            ((this.form.controls.army_service.value == '1') || (this.form.controls.army_service.value == '5')) ? 
            [Validators.required, ValidationService.specialCharactesValidator] : []);
        this.form.controls.content.setValue("");
    }

    selectedCounrty_changed() {
        if (this.form.controls.residence_country.value == '710')
            this.form.controls.state.enable();
        else {
            this.form.controls.state.disable(); 
            this.form.controls.state.setValue("");
        }      
    }

    isValid() {
        let isValid = this.baseService.isFormDatesValid(this.form, 1);

        if (this.form.invalid || !isValid) {
            this.form.markAllAsTouched();
            this.activateMe.emit();
            return false;
        }
        return true;
    }
    Head = "1";
    onSubmit() {
        if (!this.isValid()) {
          return false;
        }

        this.baseService.setPartnerProperty(this.form);

        this.isSubmited = true;
        this.maritalStatusChanged();
        this.childrenUp18NumberChanged();
        return true;
    }
    
    isHasReturningWithChildernUp18() {
        return this.form.controls.children_up18_num.value > '00';
    }

    maritalStatusChanged() { 
        let isMarid = this.form.value.marital_status == 2;
        this.form.controls.partner_returning.setValidators(isMarid ? [Validators.required] : null);
        this.form.controls.partner_returning.updateValueAndValidity();
        if (this.isSubmited) {
            this.showTab.emit({ tabIdx: 1, isShow: this.baseService.isPartnerReturning(this.form.value)});
            this.baseService.clearMainErrorMessage();
        }
    }

    childrenUp18NumberChanged() {
        if (this.isSubmited) {
            this.showTab.emit({ tabIdx: 2, isShow: this.isHasReturningWithChildernUp18()});
            this.baseService.clearMainErrorMessage();
        }    
    }
  }